import { useMutation, queryCache } from "react-query-legacy";
import { message } from "antd";
import { BillingEngineService } from "services";
import { WarehouseLoggedHoursUpdateRequest } from "services/BillingEngineService/interfaces/requests/WarehouseLoggedHours";
import { hoursLoggedQueryKey } from "../constants";

function updateWarehouseHours({ type, record }: WarehouseLoggedHoursUpdateRequest) {
  const { workersCount, hoursWorked = 0, minutesWorked = 0, notes = "", id } = record;

  const updates = {
    id,
    workersCount,
    hoursWorked,
    minutesWorked,
    notes,
  };

  return BillingEngineService.updateWarehouseHours({ record: updates, type });
}

function useQueryUpdateHours() {
  return useMutation(updateWarehouseHours, {
    onSuccess: (response, { type }) => {
      message.success("Updated row");
      queryCache.refetchQueries([hoursLoggedQueryKey, type]);
    },
  });
}

export default useQueryUpdateHours;
